/*
 *
 * File JS per la Storia PAGE
 *
 */

import Swiper, { EffectFade, Autoplay, A11y, Navigation } from "swiper";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./storia.scss";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

const storia = () => {
  const wrapperStory = document.querySelector(".wrapper-swiper-story");
  if (!wrapperStory) return;

  // Swiper: Slider
  const storiaSwiper = new Swiper(".wrapper-swiper-story .swiper-container", {
    modules: [Navigation, A11y],
    grabCursor: true,
    spaceBetween: 80,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next-story",
      prevEl: ".swiper-button-prev-story",
    },
    breakpoints: {
      1920: {
        slidesPerView: 3,
        spaceBetween: 100,
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      730: {
        slidesPerView: 1.2,
        spaceBetween: 10,
      },
    },
    A11y: {
      enabled: true,
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      notificationClass: "swiper-notification",
    },
  });

  const timeLine = document.querySelector(".time-line");
  if (!timeLine) return;

  const timeLineCard = timeLine.querySelectorAll(".time-line-card");

  timeLineCard.forEach((card) => {
    const swiperCard = card.querySelector(".time-line-card__media");

    const swiper = new Swiper(swiperCard, {
      modules: [EffectFade, A11y, Autoplay],
      effect: "fade",
      crossFade: true,
      autoplay: {
        delay: 800,
      },
      A11y: {
        enabled: true,
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}",
        notificationClass: "swiper-notification",
      },
    });
    swiper.autoplay.stop();

    let isCardVisible = false;
    function checkCardVisibility() {
      const cardRect = card.getBoundingClientRect();
      const visibleHeight = Math.max(0, Math.min(cardRect.bottom, window.innerHeight) - Math.max(cardRect.top, 0));
      
      if (visibleHeight >= 400) {
        if (!isCardVisible) {
          swiper.autoplay.start(); 
          isCardVisible = true;
          toggleClassMainWrapperSlider(card, true)
        }
      } else {
        if (isCardVisible) {
          swiper.autoplay.stop();
          isCardVisible = false;
          toggleClassMainWrapperSlider(card, false)

        }
      }
    }

    window.addEventListener("scroll", checkCardVisibility);
    window.addEventListener("resize", checkCardVisibility);

    checkCardVisibility();

  });


  function toggleClassMainWrapperSlider(card, isActive){
    const id = card.id;
    const wrapperSlider = document.querySelector('.general-swiper-story');
    const currentElement = wrapperSlider.querySelector(`[href="#${id}"]`)

    if(isActive){
      currentElement.classList.add('active')
      swipeMainWrapperSliderByID(id)
    }else{
      currentElement.classList.remove('active')
    }
    
  }

  function swipeMainWrapperSliderByID(id) {
    let currentSlider = document.querySelector(`.general-swiper-story [data-id="${id}"]`);
    let sliderIndex = Array.from(currentSlider.parentNode.children).indexOf(currentSlider);
  
    return storiaSwiper.slideTo(sliderIndex);
  }
  


};
storia();

export default storia;
